module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "my-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 overline grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.window === 0,
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n      back")], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "dark": ""
    }
  }, [(_vm.selectedLocation) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.selectedLocation.name) ? _c('v-list-tile-title', [_vm._v("\n        Moving: " + _vm._s(_vm.selectedLocation.name) + ":\n        "), (_vm.fromSpace) ? _c('span', [_vm._v(" from " + _vm._s(_vm.fromSpace.title))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v(" "), (_vm.toSpace) ? _c('span', [_vm._v(" to " + _vm._s(_vm.toSpace.title))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedLocation.address) ? _c('v-list-tile-sub-title', [_vm._v("\n        " + _vm._s(_vm.selectedLocation.address) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.window === 0) ? _c('v-btn', {
    staticClass: "px-2",
    attrs: {
      "disabled": !_vm.toSpace || !_vm.toSpace.id,
      "loading": _vm.requests.setproducts.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.move
    }
  }, [_vm._v("\n          Move location\n      ")]) : _vm._e(), _vm._v(" "), (_vm.window === 1) ? _c('v-btn', {
    staticClass: "px-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.setProducts
    }
  }, [_vm._v("\n        Set appointment types\n      ")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-window', {
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Which space would you like to move this location to\n        ")]), _vm._v(" "), _c('v-card-text', [_c('space-picker', {
    attrs: {
      "is-owner": "",
      "multiple": false,
      "attrs": _vm.attrs,
      "label": "Choose a space"
    },
    model: {
      value: (_vm.selectedSpace),
      callback: function($$v) {
        _vm.selectedSpace = $$v
      },
      expression: "selectedSpace"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.toSpace && _vm.selectedLocation) ? _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Set the appointment types for " + _vm._s(_vm.selectedLocation.name) + " at " + _vm._s(_vm.toSpace.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('v-layout', [(_vm.fromSpace && _vm.toSpace) ? _c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h3', {
    staticClass: "subheading pl-0"
  }, [_vm._v("\n              1. Which appointment types would you like to\n              " + _vm._s(_vm.action) + ":"), _c('br'), _vm._v("\n              from: "), _c('strong', [_vm._v(_vm._s(_vm.fromSpace.title))]), _vm._v("\n              to: "), _c('strong', [_vm._v(_vm._s(_vm.toSpace.title))])]), _vm._v(" "), _c('v-alert', {
    staticClass: "pa-1 my-2",
    attrs: {
      "value": true,
      "type": "info",
      "dismissible": ""
    }
  }, [_vm._v("\n              This will " + _vm._s(_vm.action) + " the selected appointment types from this space to the new space\n            ")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.action),
      callback: function($$v) {
        _vm.action = $$v
      },
      expression: "action"
    }
  }, [_c('v-radio', {
    attrs: {
      "hide-details": "",
      "label": "Move",
      "value": "move"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "hide-details": "",
      "label": "Copy",
      "value": "copy"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.fromSpace.products), function(product) {
    return [_c('v-checkbox', {
      key: product.id,
      staticClass: "caption",
      attrs: {
        "hide-details": "",
        "value": product.id,
        "label": product.title
      },
      model: {
        value: (_vm.moveProducts),
        callback: function($$v) {
          _vm.moveProducts = $$v
        },
        expression: "moveProducts"
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.toSpace) ? _c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h3', {
    staticClass: "subheading pl-0"
  }, [_vm._v("\n              2. Which appointment types (available in " + _vm._s(_vm.toSpace.title) + ")"), _c('br'), _vm._v("\n              would you like to assign to this location\n            ")]), _vm._v(" "), _c('v-alert', {
    staticClass: "pa-1 my-2",
    attrs: {
      "dismissible": "",
      "tile": "",
      "dense": "",
      "type": "info",
      "value": true
    }
  }, [_vm._v("\n              This will make the selected appointment type available in this location\n            ")]), _vm._v(" "), _vm._l((_vm.getProducts(_vm.toSpace.products)), function(product) {
    return [_c('v-checkbox', {
      key: product.id,
      staticClass: "caption",
      attrs: {
        "hide-details": "",
        "value": product.id,
        "label": _vm.getLabel(product)
      },
      model: {
        value: (_vm.assignProducts),
        callback: function($$v) {
          _vm.assignProducts = $$v
        },
        expression: "assignProducts"
      }
    })]
  })], 2) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd54ce9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/MoveLocation.vue
// module id = 1327
// module chunks = 9